import React from 'react'
import PropTypes from 'prop-types'
import ModalContainer from '@/modern/components/ModalContainer'
import { Modal, Container, Header, Info, Button } from './style'

const ModalAdReportLimit = ({ show, handleCloseModal }) => {
  return (
    <Modal>
      <ModalContainer
        show={show}
        useWhiteBox
        noBorder
        useClose
        onBgClick={handleCloseModal}
      >
        <Container>
          <Header>Limite de denúncias atingido</Header>
          <Info>
            Você atingiu o limite máximo de denúncias para este anúncio. Nossa
            equipe já está trabalhando para tomar todas as providências
            cabíveis.
          </Info>
          <Button onClick={handleCloseModal}>Entendi</Button>
        </Container>
      </ModalContainer>
    </Modal>
  )
}

ModalAdReportLimit.propTypes = {
  show: PropTypes.bool,
  handleCloseModal: PropTypes.func,
}

ModalAdReportLimit.defaultProps = {
  show: false,
  handleCloseModal: () => null,
}

export default ModalAdReportLimit
